import {OrgFaqHelp} from 'organization/Help/FAQ'
import OrganizationInvoices from 'organization/Invoices/Invoices'
import OrganizationTransactions from 'organization/Invoices/Transactions'
import CreateInvoiceModal from 'organization/Invoices/Transactions/CreateInvoiceModal'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import OrganizationPage from 'organization/theme/OrganizationPage'
import React, {useState} from 'react'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'

type TabKey = 'companies' | 'invoices' | 'transactions'

export function Invoices() {
  const {t} = useI18n()
  const [tab, setTab] = useState<TabKey>('invoices')

  return (
    <OrganizationPage
      modals={
        <>
          <CreateInvoiceModal />
        </>
      }
    >
      <div className="row pl-30 pb-30 pr-30">
        <BreadcrumMenu
          title={t('org.menu.invoicing')}
          helpInfo={<OrgFaqHelp faqKey="invoices" />}
        />

        <Tabs>
          <TabButton
            $active={tab === 'invoices'}
            onClick={() => setTab('invoices')}
          >
            {t('org.menu.invoices')}
          </TabButton>
          <TabButton
            $active={tab === 'transactions'}
            onClick={() => setTab('transactions')}
          >
            {t('org.menu.transactions')}
          </TabButton>
        </Tabs>
        {tab === 'invoices' && <OrganizationInvoices />}
        {tab === 'transactions' && <OrganizationTransactions />}
      </div>
    </OrganizationPage>
  )
}

const Tabs = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 18px;
`

const TabButton = styled.button<{$active: boolean}>`
  padding: 12px 18px;
  border-radius: 8px;
  border: 2px solid ${({$active}) => ($active ? '#f7426f' : '#e6e6e6')};
  background: ${({$active}) => ($active ? 'rgba(247,66,111,0.12)' : '#fff')};
  color: ${({$active}) => ($active ? '#f7426f' : '#666')};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${({$active}) => ($active ? '#f7426f' : '#d0d0d0')};
    background: ${({$active}) =>
      $active ? 'rgba(247,66,111,0.15)' : '#f5f5f5'};
  }

  &:active {
    transform: scale(0.98);
  }
`
